export default {"src":"https://assets.madeeasy.in/prod/_next/static/media/calendar.fd36bb4d.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};